import React, { useEffect, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import { useDispatch } from "react-redux";
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Layout from './components/layout/Main';
import { DashboardDataProvider } from "./components/context/dashboardDataContext";
import SimActivation from './pages/activations/SimActivation';
import BulkActivation from './pages/activations/BulkActivation';
import PurchaseSim from './pages/inventory/PurchaseSim';
import PurchaseSimList from './pages/inventory/PurchaseSimList';
import InventoryTransfer from './pages/inventory/InventoryTransfer';
import { AlertContainer } from './components/utils/ToastAlert';
import SimList from './pages/inventory/SimList';
import SimPlanMapping from './pages/inventory/SimPlanMapping';
import SingleRecharge from './pages/recharge/SingleRecharge';
import BulkRecharge from './pages/recharge/BulkRecharge';
import ActivationReport from './pages/reports/ActivationReport';
import RechargeReport from './pages/reports/RechargeReport';
import BatchActivationReport from './pages/reports/BatchActivationReport';
import BatchRechargeReport from './pages/reports/BatchRechargeReport';
import MDNSwapReport from './pages/reports/MDNSwapReport';
import SIMSwapReport from './pages/reports/SIMSwapReport';
import WIFIBatchReport from './pages/reports/WIFIBatchReport';
import MDNSwap from './pages/swap/MDNSwap';
import SIMSwap from './pages/swap/SIMSwap';
import CancelWiFi from './pages/wifi/CancelWiFi';
import WiFiActivation from './pages/wifi/WiFiActivation';
import CheckStatus from './pages/checkstatus/CheckStatus';
import PortinCheckStatus from './pages/checkstatus/PortinCheckStatus';
import PageNotFound from './pages/PageNotFound';
import Dealer from './pages/admin/Dealer';
import User from './pages/admin/User';

const PageLoader = () => (
  <div className="d-flex justify-content-center align-items-center">
    <div className="text-center">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
);


function App() {

  const isAuthenticated = () => {
    let token = localStorage.getItem("colt_wireless_token");
    if (token) {
      let decodedToken = jwtDecode(token);
      let currentDate = new Date();
      if (decodedToken.exp * 1000 < currentDate.getTime()) {
        localStorage.removeItem("colt_wireless_token");
        return false;
      }
      else {
        return true;
      }
    } else {
      localStorage.removeItem("colt_wireless_token");
      return false;
    }

  }


  return (
    <div className="admin-container position-relative overflow-hidden">
      <DashboardDataProvider>
        <AlertContainer />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/login" element={isAuthenticated() ? <Navigate to="/" /> : <Login />} />
            <Route path='*' element={<PageNotFound/>}/>
            <Route path="/" element={!isAuthenticated() ? <Navigate to="/login" /> : <Layout />} >
              <Route path="/" element={<Dashboard />} />
               <Route path="/admin/dealer" element={<Dealer />} />
              <Route path="/admin/user" element={<User />} />
              <Route path="/inventory/purchase-sim" element={<PurchaseSim />} />
              <Route path="/inventory/purchase-sim-list" element={<PurchaseSimList />} />
              <Route path="/inventory/inventory-transfer" element={<InventoryTransfer />} />
              <Route path="/inventory/sim-list" element={<SimList />} />
              <Route path='/inventory/sim-plan-mapping' element={<SimPlanMapping />} />
              <Route path="/activation/bulk-activation" element={<BulkActivation />} />
              <Route path="/activation/sim-activation" element={<SimActivation />} />
              <Route path="/recharge/single-recharge" element={<SingleRecharge />} />
              <Route path='/recharge/bulk-recharge' element={<BulkRecharge />} />
              <Route path="/reports/activation-report" element={<ActivationReport />} />
              <Route path='/reports/recharge-report' element={<RechargeReport />} />
              <Route path='/reports/batch-activation-report' element={<BatchActivationReport />} />
              <Route path='/reports/batch-recharge-report' element={<BatchRechargeReport />} />
              <Route path='/reports/mdn-swap-report' element={<MDNSwapReport />} />
              <Route path='/reports/sim-swap-report' element={<SIMSwapReport />} />
              <Route path='/reports/wifi-batch-report' element={<WIFIBatchReport />} />
              <Route path='/swap/mdn-swap' element={<MDNSwap />} />
              <Route path='/swap/sim-swap' element={<SIMSwap />} />
              <Route path='/wifi/cancel-wifi' element={<CancelWiFi />} />
              <Route path='/wifi/wifi-activation' element={<WiFiActivation />} />
              <Route path='/checkStatus/check-status' element={<CheckStatus />} />
              <Route path='/checkStatus/portin-check-status' element={<PortinCheckStatus />} />
            </Route>
          </Routes>
        </Suspense>
      </DashboardDataProvider>
    </div>
  );
}

export default App;